import {AxiosError} from 'axios';
import {GET_SCHOOL_CANDIDATE_APPEAL_PAYMENT_WINDOW_STATUS_URL} from '../../constants/apiUrls';
import {GET_SCHOOL_CANDIDATE_APPEAL_PAYMENT_OPEN_PERIOD_QUERY_KEY} from '../../constants/queryKeys';
import axiosClient from '../../api-refactored/axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';

// =============================================================================
// Query
// =============================================================================

interface OpenPeriodResponse {
  openWindowPeriod: boolean;
}

interface Input {
  onSuccess?: (data: OpenPeriodResponse) => void;
  onError?: (error: AxiosError) => void;
}

export const useGetSchoolCandidateAppealPaymentOpenPeriod = ({onSuccess, onError}: Input) => {
  const getSchoolCandidateAppealPaymentOpenPeriod = async () => {
    const res = await axiosClient.get<OpenPeriodResponse>(GET_SCHOOL_CANDIDATE_APPEAL_PAYMENT_WINDOW_STATUS_URL);

    return res.data;
  };

  return useCustomQuery(
      GET_SCHOOL_CANDIDATE_APPEAL_PAYMENT_OPEN_PERIOD_QUERY_KEY,
      getSchoolCandidateAppealPaymentOpenPeriod,
      {
        onSuccess,
        onError,
        staleTime: Infinity,
      },
      false
  );
};
